import service from '../service.js'

export default{

    searchConsiderationRequest(search){
        return service.get('consideration-request',
        {
            search : search
        })
    },

    endorseLeaveRequest(consi_key){
        return service.post('endorse-request',
        {
            consi_key : consi_key
        })
    },

    approveConsiderationRequest(consi_key){
        return service.post('approve-request',
        {
            consi_key : consi_key
        })
    },
}